import { Link } from "react-router-dom";
import { ReactElement } from "react";

export default function PrivacyPolicyBanner(): ReactElement {
  return (
    <section className="disclaimer-banner">
      <h1><span>Privacy Policy</span></h1>
      <nav aria-label="breadcrumb">
        <ol className="disclaimer-breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li className="font-semibold" aria-current="page">&gt; Privacy Policy</li>
        </ol>
      </nav>
    </section>
  );
}
